/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PriceListItemResponse } from '../types/PriceListItem';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PriceListItemsRetrieveRequest = {} | null | undefined;
export type PriceListItemsRetrieveResponse = PriceListItemResponse;

export type PriceListItemsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this price list item.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/price_list_items/{id}/
 *
 * ```yaml
 * operationId: price_list_items_retrieve
 * tags:
 *   - price_list_items
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PriceListItem'
 *     description: ''
 * ```
 */
export const priceListItemsRetrieveOperation = ({ id, ...rest }: PriceListItemsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/price_list_items/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/price_list_items/{id}/' };
  };

/**
 * GET /dmx-server/price_list_items/{id}/
 *
 * ```yaml
 * operationId: price_list_items_retrieve
 * tags:
 *   - price_list_items
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PriceListItem'
 *     description: ''
 * ```
 */
export const priceListItemsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PriceListItemsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PriceListItemResponse>> => {
  const operation = priceListItemsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/price_list_items/{id}/
 */
export const usePriceListItemsRetrieveResource = (
  query: PriceListItemsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<PriceListItemsRetrieveResponse> => {
  return useResource<PriceListItemsRetrieveResponse>({
    path: query === null ? null : priceListItemsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
